const logoutDetails = (state = null, action) => {
  if (action.type === "SET_LOGOUT_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_LOGOUT_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default logoutDetails;
